export default __webpack_public_path__ + "static/media/Blighted Halberd.23f70697.jpg";